export default Validator => {
  Validator.register(
    'vimeo',
    function (value) {
      return new RegExp(
        /(?:https?:\/\/)?(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+).*[^\/]$/,
      ).test(value)
    },
    ':attribute er ikke gyldig',
  )
}
